import { translationStatistics_da } from "./translationStatistics.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationStatistics_en } from "./translationStatistics.en";

export const translationStatistics = defineBilingualTranslations({
  da: translationStatistics_da,
  en: translationStatistics_en,
});
